import React from "react";
import SEO from "@/components/SEO";
import ServiceLocationTemplate from "@/components/ServiceLocationTemplate";

const HadfieldEmergencyDentistPage = () => (
  <ServiceLocationTemplate suburbName="Hadfield" suburbSlug="hadfield" variant="emergency-dentist" />
);

export default HadfieldEmergencyDentistPage;
